import { useState, useEffect, useMemo } from "react";
import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import Sidenav from "examples/Sidenav";

import Configurator from "examples/Configurator";
import theme from "assets/theme";

import themeDark from "assets/theme-dark";
// RTL plugins

import Dashboard from "layouts/dashboard";

import routes from "routes";
import AddSchool from "layouts/addschool";

import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images

import ProtectedRoute from "layouts/authentication/ProtectedRoute";
import LoginRoute from "layouts/authentication/LoginRoute";

import Permission from "layouts/staffPermision";
import SignIn from "layouts/authentication/sign-in";
import AddAdmin from "./layouts/AddAdmin/AddAdmin";
import Roles from "./layouts/Roles/Roles";
import AddBranch from "./layouts/AddBranch/AddBranch";
import BranchReport from "./layouts/BranchReport/BranchReport";
import BranchSettings from "./layouts/BranchSettings/BranchSettings";
import TemplateSettings from "./layouts/BranchSettings/TemplateSettings";
import SingleBranchReport from "./layouts/BranchReport/SingleBranchReport";
import Billing from "layouts/billing";
import Payment from "layouts/Payment";
import Commission from "layouts/Commission";
import InvoicePage from "layouts/InvoivcePage";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,

    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  const [isSignedIn, setIsSignedIn] = useState(null)

  // Cache for the rtl
  // useMemo(() => {
  //   // const cacheRtl = createCache({
  //   //   key: "rtl",
  //   //   stylisPlugins: [rtlPlugin],
  //   });

  //  // setRtlCache(cacheRtl);
  // }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
 // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
   // document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {

    
   setIsSignedIn(localStorage.getItem("LoginStatus"));

   console.log("loginStatus",localStorage.getItem("LoginStatus"));
   // document.documentElement.scrollTop = 0;
  //  document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {}, []);



  const getRoutes = (allRoutes) =>
 
  allRoutes.map((route) => {
    console.log("aaaaaa", route.route)
    if (route.collapse) {
      return getRoutes(route.collapse);
    }

    if (route.route) {
      if(route.component=="authentication/sign-in")
      {
        return <Route exact path={route.route} element={<LoginRoute isSignedIn={isSignedIn}>{route.component}</LoginRoute> } key={route.key} />;
      }
      else
      return <Route exact path={route.route} element={<ProtectedRoute isSignedIn={isSignedIn}>{route.component}</ProtectedRoute> } key={route.key} />;
     
    }

    return null;
  });

 

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brandName="UBK Pro Admin"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
         
         
        </>
      )}
      <Routes>
      
       <Route exact path="/" element={<LoginRoute isSignedIn={isSignedIn}><SignIn/></LoginRoute>} />
       <Route path="/dashboard" element={ <ProtectedRoute isSignedIn={isSignedIn}><Dashboard /></ProtectedRoute> } />
       <Route path="/adminpasslogin" element={ <LoginRoute isSignedIn={isSignedIn}><SignIn /></LoginRoute> } />
       <Route path="/Permission" element={ <ProtectedRoute isSignedIn={isSignedIn}><Permission /></ProtectedRoute> } />
       <Route path="/AddSchool" element={ <ProtectedRoute isSignedIn={isSignedIn}><AddSchool /></ProtectedRoute> } />
       <Route path="/AddAdmin" element={ <ProtectedRoute isSignedIn={isSignedIn}><AddAdmin /></ProtectedRoute> } />
       <Route path="/Roles" element={ <ProtectedRoute isSignedIn={isSignedIn}><Roles /></ProtectedRoute> } />
       <Route path="/Branches" element={ <ProtectedRoute isSignedIn={isSignedIn}><AddBranch /></ProtectedRoute> } />
       <Route path="/BranchReport" element={ <ProtectedRoute isSignedIn={isSignedIn}><BranchReport /></ProtectedRoute> } />
       <Route path="/BranchSettings" element={ <ProtectedRoute isSignedIn={isSignedIn}><BranchSettings /></ProtectedRoute> } />
       <Route path="/TemplateSettings" element={ <ProtectedRoute isSignedIn={isSignedIn}><TemplateSettings /></ProtectedRoute> } />
       <Route path="/SingleBranchReport" element={ <ProtectedRoute isSignedIn={isSignedIn}><SingleBranchReport /></ProtectedRoute> } />
       
        <Route path="/Billing" element={ <ProtectedRoute isSignedIn={isSignedIn}><Billing /></ProtectedRoute> } />
        <Route path="/Payment" element={ <ProtectedRoute isSignedIn={isSignedIn}><Payment /></ProtectedRoute> } />
        <Route path="/Commission" element={ <ProtectedRoute isSignedIn={isSignedIn}><Commission /></ProtectedRoute> } />
        <Route path="/invoicePage" element={<ProtectedRoute isSignedIn={isSignedIn}><InvoicePage /></ProtectedRoute>} />
      </Routes>
    </ThemeProvider>
  );
}
